module.exports = __webpack_public_path__ + "img/southend.4207a0e4.jpg";